<template>
    <modal :saveAction="false" :title="title" :id="id" :actionButtons="false" size="lg" scrollable @shown="shown" @hidden="hidden">
        <div class="row align-items-top">
            <div class="col-12 col-md-4">
                <div class="card">
                    <div class="card-body">
                        <div v-for="(service, index) in services" :key="index">
                            <div class="row align-items-center active">
                                <div class="col-auto" v-if="service._id === serviceId">
                                    <a href="#" @click.prevent="serviceId = null">
                                        <i class="fe fe-x"></i>
                                    </a>
                                </div>
                                <div class="col ml-n2">
                                    <h4 class="card-title mb-1">
                                        <a href="#" @click.prevent="serviceId = service._id">{{service.label}}</a>
                                        <span class="badge badge-soft-primary ml-2">{{service.totalTreatments}}</span>
                                    </h4>
                                </div>
                            </div>
                            <hr/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-8" v-if="serviceId">
                <div class="card mb-2" v-for="(treatment, treatmentIndex) in treatments" :key="treatmentIndex">
                    <div @click="use(treatment)" class="card-body d-flex justify-content-between align-items-center p-2 pointer hover">
                        <h4 class="card-title mb-1 name">
                            <i
                                class="fe fe-package mr-1"
                                v-b-tooltip
                                :title="$t('Includes services or products')"
                                v-if="treatment.bundle && treatment.bundle.length>0"
                            ></i>
                            {{treatment.label}}
                            <p class="text-muted small mb-0 mt-1">
                                <money :value="treatment.price"></money>
                            </p>
                        </h4>

                        <button class="btn">
                            <i class="fe fe-chevron-right h1 p-0 m-0"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <template slot="modal-footer">
            <div class="card-footer"></div>
        </template>
    </modal>
</template>

<script>
import Money from "@/components/Money.vue";
import Modal from "@/components/Modal.vue";
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'work-select-modal',
    props: { id: String, saveAction: Function, technicianId: null },
    components: {
        Money,
        Modal,
    },
    watch: {
        serviceId(newValue) {
            this.$set(this.treatmentsQuery, 'serviceId', newValue);
        },

        technicianId() {
            this.fetchData()
        }
    },
    computed: {
        ...mapGetters('technicians-treatment', { findTreatmentsInStore: 'find' }),
        ...mapGetters('technicians-service', { findServicesInStore: 'find' }),

        treatments() {
            return this.findTreatmentsInStore({ query: this.treatmentsQuery }).data;
        },

        services() {
            return this.findServicesInStore({ query: this.servicesQuery }).data
        }
    },
    data() {
        return {
            title: '',
            serviceId: null,
            treatmentsQuery: {},
            servicesQuery: {}
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        ...mapActions('technicians-treatment', { findTreatments: 'find' }),
        ...mapActions('technicians-service', { findServices: 'find' }),

        use(treatment) {
            this.saveAction(treatment);
            this.close()
        },

        fetchData() {
            let query = { technicianId: this.technicianId };
            this.findTreatments({ query }).then(console.log);
            this.findServices({ query }).then(console.log)
        },

        close() {
            this.$root.$emit('bv::hide::modal', this.id)
        },

        shown() {

        },

        hidden() {

        }
    }
}
</script>
